export const ColumnTypes = {
  Text: "Text",
  TextWithEdit: "TextWithEdit",
  TextNumber: "TextNumber",
  SelectMenuWithEdit: "SelectMenuWithEdit",
  Date: "Date",
  DateWithEdit: "DateWithEdit",
  ProfileDisplayName: "ProfileDisplayName",
  ProfileEmail: "ProfileEmail",
  ProfileAddress: "ProfileAddress",
  ProfileContactInformation: "ProfileContactInformation",
  ProfileDegree: "ProfileDegree",
  ProfileTag: "ProfileTag",
  Boolean: "Boolean",
  Template: "Template",
  WorkflowInstancePossibleActions: "WorkflowInstancePossibleActions",
  WorkflowInstanceStatus: "WorkflowInstanceStatus",
  ArrayJoin: "ArrayJoin",
  ArrayFind: "ArrayFind",
  ArrayFilter: "ArrayFilter",
  ArrayCount: "ArrayCount",
  ArraySum: "ArraySum",
  NestedTable: "NestedTable",
  TextRegexReplace: "TextRegexReplace",
  CreateModified: "CreateModified",
} as const;
